import React, { useEffect, useRef, useState } from 'react'
import styles from '../common.module.scss';
import { Spinner } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom'
import InputOTP from 'react18-input-otp';
import api from "../helpers/crmApis";
import { Toast } from 'primereact/toast';
import { decodeData, encodeData } from './Constant/Constant';

export default function VerifyOtp() {
    const toast = useRef(null);
    const location = useLocation();
    const navigate = useNavigate();
    const [loginOtp, setLoginOtp] = useState('');
    const [pageQuery, setPageQuery] = useState(null);
    const [isVerifyOtpLoading, setIsVerifyOtpLoading] = useState(false);
    const [resendTime, setResendTime] = useState(60);

    const handleVerifyOtp = async () => {
        try {
            setIsVerifyOtpLoading(true);
            let res = await api.get(`/auth/verify-email?email=${pageQuery?.email}&otp=${loginOtp}`);
            if (res?.data) {
                setIsVerifyOtpLoading(false);
                const payload = {
                    isValid: true,
                    email: pageQuery?.email,
                };

                const encodedQuery = encodeData(payload);
                // navigate(`/onboarding?query=${encodeURIComponent(JSON.stringify({ isValid: true, email: pageQuery?.email }))}`);
                navigate(`/onboarding?query=${encodedQuery}`);
            } else {
                setIsVerifyOtpLoading(false);
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Invalid OTP' });
            }
        } catch (error) {
            setIsVerifyOtpLoading(false);
            console.error("Error verifying otp:", error);
        }
    }

    const handleResendCode = async () => {
        try {
            if (resendTime > 0) return;
            let res = await api.get(`/auth/resend-otp?email=${pageQuery?.email}`);
            if (res?.status == 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: 'OTP resent successfully' });
                setResendTime(60);
                setLoginOtp('');
            }
        } catch (error) {
            console.error("Error resending code:", error);
        }
    };

    const handleOtpChange = (otp) => {
        setLoginOtp(otp);
    };

    useEffect(() => {
        if (resendTime <= 0) return;

        const timer = setInterval(() => {
            setResendTime((prev) => {
                if (prev <= 1) {
                    clearInterval(timer);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [resendTime]);
    
    // I will remove the commented code after verifying that the new logic is working correctly
    // useEffect(() => {
    //     const queryParams = new URLSearchParams(location.search);
    //     let queryData = queryParams.get("query");
    //     queryData = queryData ? JSON.parse(decodeURIComponent(queryData)) : null;
    //     if (queryData?.isValid) {
    //         setPageQuery(queryData);
    //     } else {
    //         navigate('/signup');
    //     }
    // }, [location])

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const token = queryParams.get('query');

        const queryData = decodeData(token);

        if (queryData?.isValid) {
            setPageQuery(queryData);
        } else {
            navigate('/signup');
        }
    }, [location]);

    return (
        <div className='flex flex-col justify-center items-center h-screen'>
            <Toast ref={toast} />
            <div>
                <img src="/images/crileo-logo.png" alt="logo" className='object-cover w-[150px] h-[80px]' />
            </div>
            <div className={`p-5 ${styles.verifyOtpContainer}`}>
                <div className={`flex flex-col justify-center items-center mb-3`}>
                    <h3 className="text-[18px]">Welcome</h3>
                    <h5 className='text-stone-500 text-[14px] mt-4'>We’ve sent a verification code to email address</h5>
                    <p>
                        <span className={`${styles.loginMail}`}>{pageQuery?.email}</span>{' '}
                        <span onClick={() => navigate('/signup')} className={`${styles.wrongMailText} ps-1`}>Wrong Email</span><span>{' '}?</span>
                    </p>
                </div>

                <div className={`${styles.loginPageTabs} flex justify-around`}>
                    <form>
                        <div className={`${styles.otpInputs} mt-[2rem]`}>
                            <InputOTP
                                numInputs={6}
                                isInputNum={true}
                                onChange={handleOtpChange}
                                value={loginOtp}
                                autoFocus
                                shouldAutoFocus
                                placeholder={'------'}
                            />
                        </div>
                        
                        <button
                            type="button"
                            className="btn px-3 w-full h-[36px] bg-[#101828] disabled:bg-[#5f5e5e] text-white rounded-[8px] flex items-center justify-center gap-2 mt-[3.5rem]"
                            onClick={() => handleVerifyOtp()}
                            disabled={isVerifyOtpLoading}
                        >
                            {isVerifyOtpLoading &&
                                <div role="status">
                                    <svg aria-hidden="true" class="inline w-8 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-gray-600 dark:fill-gray-300" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                                    </svg>
                                    <span class="sr-only">Loading...</span>
                                </div>
                            }
                            Verify OTP
                        </button>
                        <div className='flex justify-between mt-3'>
                            <span onClick={() => handleResendCode()} className={`${resendTime > 0 ? 'text-[#717182] cursor-not-allowed' : 'text-[#101828] cursor-pointer'}`}>resend OTP</span>
                            {resendTime > 0 &&<span>{resendTime}s</span>}
                        </div>
                    </form>
                </div>
            </div>
            <div className='mt-5'>
                <span className='text-[#717182] fs-5'>By continuing, you agree to our <a className='text-[#717182] underline' href='https://crileo.com/terms-of-service/' target='_blank'>Terms of Service</a> and <a className='text-[#717182] underline' href='https://crileo.com/privacy-policy/' target='_blank'>Privacy Policy</a></span>
            </div>
        </div>
    )
}
